import React from 'react';
import { Link } from 'react-router-dom';
import { BlogPost } from '../services/blogService';
import { Clock, User, Eye } from 'lucide-react';

interface BlogCardProps {
  post: BlogPost;
}

const BlogCard: React.FC<BlogCardProps> = ({ post }) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('pt-BR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const parseKeywords = (keywords: string): string[] => {
    try {
      return JSON.parse(keywords);
    } catch {
      return [];
    }
  };

  const parsedKeywords = parseKeywords(post.keywords);

  return (
    <article className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
      <Link to={`/blog/${post.slug}`}>
        <div className="relative">
          <img
            src={post.featured_image}
            alt={post.title}
            className="w-full h-48 object-cover"
            onError={(e) => {
              e.currentTarget.src = '/default-blog.svg';
            }}
          />
          <div className="absolute top-3 right-3">
            <span className="bg-teal-500 text-white px-2 py-1 rounded-full text-xs font-medium">
              {post.category}
            </span>
          </div>
        </div>
      </Link>
      
      <div className="p-6">
        <div className="flex items-center text-sm text-gray-500 mb-3">
          <Clock className="h-4 w-4 mr-1" />
          <span className="mr-4">{post.reading_time} min</span>
          <Eye className="h-4 w-4 mr-1" />
          <span>{post.views_count} visualizações</span>
        </div>
        
        <Link to={`/blog/${post.slug}`}>
          <h3 className="text-xl font-bold text-gray-900 mb-3 hover:text-teal-600 transition-colors">
            {post.title}
          </h3>
        </Link>
        
        <p className="text-gray-600 mb-4 line-clamp-3">
          {post.excerpt}
        </p>
        
        {parsedKeywords.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-4">
            {parsedKeywords.slice(0, 3).map((keyword, index) => (
              <span
                key={index}
                className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs"
              >
                {keyword}
              </span>
            ))}
          </div>
        )}
        
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-500">
            {formatDate(post.published_at)}
          </span>
          
          <Link
            to={`/blog/${post.slug}`}
            className="text-teal-600 hover:text-teal-700 font-medium text-sm transition-colors"
          >
            Leia mais →
          </Link>
        </div>
      </div>
    </article>
  );
};

export default BlogCard;

